import { InvalidateQueries, MutationOptions, useRepositoryMutation } from '@mews-commander/data-access';

const invalidateQueries = {
    reservations: ['getAll'],
    guestInHouse: ['getReservations'],
} satisfies InvalidateQueries;

export const useAddReservationNote = (
    options: Omit<MutationOptions<'reservations', 'addNotes'>, 'invalidateQueries'>
) => useRepositoryMutation('reservations', 'addNotes', { ...options, invalidateQueries });
